import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Paper, Grid } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import ChartComponent, { Chart } from 'react-chartjs-2'
import 'chartjs-chart-treemap'
import { withStyles } from '@material-ui/core/styles'

import 'react-day-picker/lib/style.css'
import { styles } from '../../classes/Styles'
import './HomeWhatsNewComponent.scss'
import { FILTER_OUT_GENRES } from '../../constants/labels'
import { GENRE_PROFILE } from '../../constants/module_info'

class HomeBrandEngagerGenreProfileComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    homepage: PropTypes.string,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number,
    handleGenreModuleChange: PropTypes.func,
    selectedGenreChartModule: PropTypes.string
  }

  render () {
    const { classes, metrics, homepage, handleGenreModuleChange } = this.props
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={1} direction="column">
          <Grid item >
            <Grid container>
              <Grid item xl={10} lg={9} md={9} sm={9} xs={9}>
                <span className={classes.cardTitle}>Genre Profile</span>
                <OverlayTrigger overlay={<Tooltip id="tooltip">{GENRE_PROFILE}</Tooltip>} placement="right">
                  <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
                </OverlayTrigger>
              </Grid>
              <Grid item xl={2} lg={3} md={3} sm={3} xs={3} className={classes.anticipationType}>
                <img className={classes.anticipationArrow} onClick={handleGenreModuleChange} src="/static/images/antiLeft.png" alt="antiLeft"/>
                <img className={classes.anticipationArrow} onClick={handleGenreModuleChange} src="/static/images/antiRight.png" alt="antiRight"/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item className={classes.cardSubTitle}>The top media genres the {homepage} engaged audience is interested in</Grid>
        </Grid>
        { (metrics && metrics.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (metrics && metrics.details) &&
          <Grid container spacing={1}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <TreeMap
                classes={classes}
                screenWidth={this.props.screenWidth}
                metrics={metrics}
                selectedGenreChartModule={this.props.selectedGenreChartModule}
              />
            </Grid>
          </Grid>
        }
      </Paper>
    )
  }
}

class TreeMap extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    metrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number,
    selectedGenreChartModule: PropTypes.string
  }

  componentDidMount () {
    const fontSize = this.props.screenWidth < 480 ? 10 : this.props.screenWidth < 1200 ? 12 : 14
    if (this.props.selectedGenreChartModule === '') { //Fix for the font is getting bold each time
      this.registerChart(fontSize)
    }
  }

  getTitleArray = (ctx, array, bar, dispArray) =>{
    if (ctx.measureText(array).width > bar._view.width) {
      let arr = [array.substring(0, array.length/2), array.substring(array.length/2)]
      for (let i = 0; i < arr.length; i++) {
        if (ctx.measureText(arr[i]).width > bar._view.width) {
          this.getTitleArray (ctx, arr[i], bar, dispArray)
        }
        dispArray.push(arr[i])
      }
    } else {
      dispArray.push(array)
    }
  }

  registerChart (fontSize) {
    let that = this
    Chart.pluginService.register({
      afterDatasetDraw: function (chart) {
        let ctx = chart.ctx
        ctx.textAlign = 'left'
        ctx.textBaseline = 'bottom'
        ctx.fillStyle = '#000000'
        ctx.font = `${fontSize}px Uni Sans Regular`
        chart.config.data.datasets.forEach(function (dataset) {
          if (dataset.label === 'Genre Profile'){
            const dataArray = dataset.data
            const key = Object.keys(dataset._meta)
            dataset._meta[key].data.forEach(function (bar, index) {
              const string = dataArray[index]._data.displayName
              const array = string.split(' ')
              let dispArray = []
              const x = bar._view.left + 3
              let y = 0
              let arr = []
              for (let i = 0; i < array.length; i++) {
                if (ctx.measureText(array[i]).width > bar._view.width) {
                  arr = [array[i].substring(0, array[i].length/2), array[i].substring(array[i].length/2)]
                  for (let i = 0; i < arr.length; i++) {
                    that.getTitleArray (ctx, arr[i], bar, dispArray)
                  }
                } else {
                  dispArray.push(array[i])
                }
              }
              y = Math.round(bar._view.y - ((dispArray.length - 1) * fontSize))
              y = Math.round(bar._view.top) < y && (y - Math.round(bar._view.top) > 10) ? y : Math.round(bar._view.top) + 15
              for (let i = 0; i < dispArray.length; i++) {
                //To avoid text overlay between boxes, if the text goes below the boundry box, no need to display it.
                if (Math.round(y) < Math.round(bar._view.top + bar._view.height) || (Math.round(y) - Math.round(bar._view.top + bar._view.height) >= 0) && (Math.round(y) - Math.round(bar._view.top + bar._view.height) < 2)) {
                  ctx.fillText(dispArray[i], x, y)
                }
                y += fontSize
              }
            })
          }
        })
      }
    })
  }

  render () {
    const { classes, metrics } = this.props
    const genreData = metrics.details && metrics.details.genre_profile.genre_profiles
    const genres = genreData.filter(f => FILTER_OUT_GENRES.indexOf(f.col) < 0)
    let tree = []
    let others = []
    genres.slice(0, 9).map(g => {
      tree.push({
        value: g.score,
        title: g.col,
        displayName: `${g.score}% ${g.col}`
      })
    })
    genres.slice(9, genres.length).map(g => {
      others.push({
        value: g.score,
        title: g.col,
        displayName: `${g.score}% - ${g.col}`
      })
    })
    tree.push({
      value: others[0].value,
      title: 'Other',
      displayName: `<${others[0].value}% Other`
    })
    const data = {
      datasets: [{
        label: 'Genre Profile',
        tree: tree,
        key: 'value',
        fontColor: '#000000',
        fontFamily: 'Uni Sans Regular',
        fontSize: 14,
        lineHeight: 14,
        backgroundColor: function (ctx) {
          var value = ctx.dataset.data[ctx.dataIndex].v
          var alpha = (1 + Math.log(value)) / 5
          //var alpha = (value + 3) / 10
          return Chart.helpers.color('#DB9EE4').alpha(alpha).rgbString()
        }
      }]
    }
    const options = {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      legend: false,
      tooltips: {
        enabled: true,
        mode: 'label',
        titleFontSize: 14,
        bodyFontSize: 14,
        position: 'nearest',
        custom: (tooltip) => {
          if (!tooltip) return
          // disable displaying the color box
          tooltip.displayColors = false
        },
        callbacks: {
          title: (tooltipItem, data) => {
            var title = data.datasets[0].tree[tooltipItem[0].index].title
            if (title === 'Other') {
              return data.datasets[0].tree[tooltipItem[0].index].displayName.replace('%', '% -')
            } else {
              return ''
            }
          },
          label: (tooltipItem, data) => {
            var value = data.datasets[0].tree[tooltipItem.index].value
            var title = data.datasets[0].tree[tooltipItem.index].title
            if (title === 'Other') {
              return others.map(o => o.displayName)
            } else {
              return `${value}% - ${title}`
            }
          }
        }
      }
    }

    return (
      <Grid item className={`${classes.genreProfileRadar} genreProfileTreeMap`}>
        <ChartComponent data={data} options={options} type='treemap' height={200}/>
      </Grid>
    )
  }
}

export default withStyles(styles)(HomeBrandEngagerGenreProfileComponent)